import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useSalaryWithCap } from '@xing-com/crate-dream-machine-hooks';

import { useDeckCardTyped } from '../../context';

import { PeakAndPop, type PeakAndPopType } from './peak-and-pop';
import Styles from './peak-and-pop-salary.style';

export const PeakAndPopSalary: React.FC<PeakAndPopType> = ({ ...props }) => {
  const getSalaryWithCap = useSalaryWithCap();
  const { data } = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const salary =
    data?.salary?.__typename === 'SalaryEstimate' ||
    data?.salary?.__typename === 'SalaryRange'
      ? data.salary
      : null;

  if (!salary || !salary.currency) {
    return null;
  }

  return (
    <PeakAndPop {...props}>
      <Styles.Title size="medium">
        <FormattedMessage id="DREAM_MACHINE_JOB_CARD_SALARY_PEEK_TITLE" />
      </Styles.Title>
      {salary.__typename === 'SalaryEstimate' && salary.median && (
        <Styles.MedianSalary size="medium">
          <FormattedNumber
            value={salary?.median}
            style="currency"
            currency={salary?.currency}
            maximumFractionDigits={0}
          />
        </Styles.MedianSalary>
      )}
      <Styles.Bar>
        <Styles.BarFill />
      </Styles.Bar>
      {(salary.__typename === 'SalaryEstimate' ||
        salary.__typename === 'SalaryRange') &&
        salary?.minimum &&
        salary.maximum && (
          <Styles.Range>
            <Styles.RangeItem size="small">
              <FormattedNumber
                value={salary.minimum}
                style="currency"
                currency={salary.currency}
                maximumFractionDigits={0}
              />
            </Styles.RangeItem>
            <Styles.RangeItem size="small">
              {getSalaryWithCap(salary.maximum, salary.currency)}
            </Styles.RangeItem>
          </Styles.Range>
        )}
      <Styles.Label>
        <Styles.LabelBarAverage />
        <Styles.LabelText size="small">
          <FormattedMessage id="DREAM_MACHINE_JOB_CARD_SALARY_PEEK_AVERAGE_LABEL" />
        </Styles.LabelText>
      </Styles.Label>
      <Styles.Label>
        <Styles.LabelBarRange />
        <Styles.LabelText size="small">
          <FormattedMessage id="DREAM_MACHINE_JOB_CARD_SALARY_PEEK_RANGE_LABEL" />
        </Styles.LabelText>
      </Styles.Label>
      <Styles.Note size="small">
        <FormattedMessage id="DREAM_MACHINE_JOB_CARD_SALARY_PEEK_NOTE" />
      </Styles.Note>
    </PeakAndPop>
  );
};
